module.exports = __webpack_public_path__ + "img/dl (2).83e0d73f.jpg";